const load = (time, setLoading) => {
  setLoading(true);
  setTimeout(() => {
    setLoading(false);
  }, time);
};

export default load;
